// ==============================
// helpers.ts
// ==============================
export const intervals = [
  { label: "Day", days: 1 },
  { label: "Week", days: 7 },
  { label: "Month", days: 30 },
  { label: "Year", days: 365 },
];

export function isWithinDays(someDate: Date, days: number) {
  const now = new Date();
  const diffInMs = now.getTime() - someDate.getTime();
  const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
  return diffInDays <= days;
}
